<app-app-shield-event-logs
  [notAvailableOptions]="{ show: true }"
  [showFilter]="true"
  [showPagination]="true" />
